import {Injectable} from '@angular/core';


@Injectable()
export class MapService {
    constructor() {
    }
}



// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/services/map.service.ts